module.exports = __webpack_public_path__ + "static/jennifer_fellman-51f939045c1ced0032996653a8cca834.jpg";